export const TryCanvasPopoverVideos = () => (
  <video
    autoPlay
    loop
    muted
    playsInline
    tabIndex={-1}
    aria-hidden="true"
    className="h-full w-full rounded-t-8 object-cover"
  >
    <source src="/videos/canvas_modal.webm" type="video/webm" />
    <source src="/videos/canvas_modal.mp4" type="video/mp4" />
  </video>
);

TryCanvasPopoverVideos.displayName = 'TryCanvasPopoverVideos';
